/* istanbul ignore file */
import { Routes } from "@angular/router";
import { SRP_ROUTES } from "./common/constants/routes";
import { PageResolver } from "./common/services/resolvers/page-resolver";
import { AuthGuard } from "./common/services/gaurds/auth.guard";
import { WspFeatureGuard } from "./common/services/gaurds/wsp.guard";
import { Login } from "./login/login";
import { canDeactivateGuard } from "./common/services/gaurds/can-deactivate.guard";

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: SRP_ROUTES.LOGIN.PATH
      },
      {
        path: SRP_ROUTES.LOGIN.PATH,
        component: Login,
        pathMatch: "full",
        data: { hideHeader: true, hideFooter: true, auth: 'avoid', hideSubHeader: true },
        canMatch: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.LANDINGPAGE.PATH,
        loadComponent: () => import('./landing-page/landing-page').then(m => m.LandingPage),
        pathMatch: "full",
        data: { auth: 'required', preload: true, hideSubHeader: true, pageCategory: 'homepage' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },

      {
        path: SRP_ROUTES.SUBSCRIPTIONS.PATH,
        loadComponent: () => import('./landing-page/subscriptions/subscriptions').then(m => m.Subscriptions),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'subscriptions' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.LOGIN_SAML_PROXY.PATH,
        loadComponent: () => import('./login-saml-proxy/login-saml-proxy').then(m => m.LoginSamlProxy),
        pathMatch: "full",
        data: { hideHeader: true, hideFooter: true, hideSubHeader: true, auth: 'partial' },
        canActivate: [AuthGuard],
      },
      {
        path: SRP_ROUTES.ORDER_PREPARATION.PATH,
        loadComponent: () => import('./saved-shopping-cart/order-distributor/order-distributor').then(m => m.OrderDistributor),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'order preparation page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.IMPORT_TO_CREATE_ORDER.PATH,
        loadComponent: () => import('./import-to-create-order/import-to-create-order').then(m => m.ImportToCreateOrder),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'import to create order page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.ORDER_DETAILS.PATH,
        loadComponent: () => import('./saved-shopping-cart/order-details/order-details').then(m => m.OrderDetails),
        pathMatch: "full",
        data: { auth: 'required', preloadRoutes: [SRP_ROUTES.ORDER_DETAILS_PREVIEW.PATH], pageCategory: 'order details page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.CART.PATH,
        loadComponent: () => import('./saved-shopping-cart/cart/cart').then(m => m.Cart),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'shopping cart page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.ESTIMATES.PATH,
        loadComponent: () => import('./my-estimates/estimates').then(m => m.Estimate),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'estimate view page', disableAutoVirtualPath: true },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }

      },
      {
        path: SRP_ROUTES.ESTIMATESPRINT.PATH,
        loadComponent: () => import('./my-estimates/estimate-print/estimate-print').then(m => m.EstimatePrint),
        //component: EstimatePrint,
        pathMatch: "full",
        data: { hideHeader: true, hideFooter: true, hideSubHeader: true },
        resolve: { pageData: PageResolver }
      },

      {
        path: SRP_ROUTES.MYORDERSVIEW.PATH,
        loadComponent: () => import('./my-orders-view/my-orders-view').then(m => m.MyOrdersView),
        pathMatch: "full",
        data: { auth: 'required', preloadRoutes: [SRP_ROUTES.ORDER_DETAILS.PATH] },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.MYRETURNORDERS.PATH,
        loadComponent: () => import('./my-return-orders/my-return-orders').then(m => m.MyReturnOrders),
        pathMatch: "full",
        data: { auth: 'required', preloadRoutes: [SRP_ROUTES.ORDER_DETAILS.PATH] },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.SETTINGS.PATH,
        loadComponent: () => import('./my-settings/my-settings').then(m => m.MySettings),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'settings page' },
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard],
        resolve: { pageData: PageResolver }

      },
      {
        path: SRP_ROUTES.SAVEDSHOPPINGCART.PATH,
        loadComponent: () => import('./saved-shopping-cart/saved-shopping-cart').then(m => m.SavedShoppingCart),
        pathMatch: "full",
        data: { auth: 'required', preloadRoutes: [SRP_ROUTES.CART.PATH], pageCategory: 'saved shopping cart page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }

      },
      {
        path: SRP_ROUTES.MYACCOUNT.PATH,
        loadComponent: () => import('./my-account/my-account').then(m => m.MyAccount),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'my account page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.ERROR_PAGE.PATH,
        loadComponent: () => import('./error-page/error-page').then(m => m.ErrorPage),
        pathMatch: "full",
        data: { auth: 'avoid' },
        // canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.SSO_ERROR_PAGE.PATH,
        loadComponent: () => import('./sso-error-page/sso-error-page').then(m => m.SsoErrorPage),
        pathMatch: "full",
        data: { auth: 'avoid' },
        // canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.LOCALSETTINGS.PATH,
        loadComponent: () => import('./local-settings/local-settings').then(m => m.LocalSettings),
        pathMatch: "full",
        data: { auth: 'required' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.ESTIMATESLIST.PATH,
        loadComponent: () => import('./estimate-list/estimate-list').then(m => m.EstimateList),
        pathMatch: "full",
        data: { auth: 'required' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.ORDER_DETAILS_PREVIEW.PATH,
        loadComponent: () => import('./order-details-preview/order-details-preview').then(m => m.OrderDetailsPreview),
        pathMatch: "full",
        data: { auth: 'required', hideHeader: true, hideFooter: true, hideSubHeader: true, pageCategory: 'order details preview page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.RETURN_ORDER_DETAILS.PATH,
        loadComponent: () => import('./return-order-details/return-order-details').then(m => m.ReturnOrderDetails),
        pathMatch: "full",
        data: { auth: 'required', pageCategory: 'return order details page' },
        canActivate: [AuthGuard]
      },
      {
        path: SRP_ROUTES.WSP_WORKSHOP_PRODUCTS.PATH,
        loadChildren: () => import('./wsp/wsp-routing').then(m => m.WSP_ROUTES),
        // pathMatch: "full",
        data: { auth: 'required' },
        canActivate: [WspFeatureGuard, AuthGuard],
        resolve: { pageData: PageResolver }
      },
      {
        path: SRP_ROUTES.STATUS_MESSAGES.PATH,
        loadComponent: () => import('./status-message-center/status-message-center').then(m => m.StatusMessageCenter),
        pathMatch: "full",
        data: { auth: 'required', hideHeader: false, hideFooter: false, hideSubHeader: false, pageCategory: 'status messages page' },
        canActivate: [AuthGuard],
        resolve: { pageData: PageResolver },
      },
      {
        path: SRP_ROUTES.VEHICLE_SEARCH_SUMMARY.PATH,
        loadComponent: () => import('./vehicle-search-summary/vehicle-search-summary').then(m => m.VehicleSearchSummary),
        pathMatch: 'full',
        data: { auth: 'required', hideHeader: false, hideFooter: false, hideSubHeader: false, pageCategory: 'vehicle search summary page'},
        canActivate: [AuthGuard],
        // resolve: { pageData: PageResolver },
      },      {
        path: SRP_ROUTES.RETURN_ORDER_DETAILS.PATH,
        loadComponent: () => import('./return-order-details/return-order-details').then(m => m.ReturnOrderDetails),
        pathMatch: "full",
        data: { auth: 'required', hideHeader: false, hideFooter: false, hideSubHeader: false, pageCategory: 'return order details page' },
        canActivate: [AuthGuard],
        // resolve: { pageData: PageResolver },
      },

      {
        path: SRP_ROUTES.MAINTENANCE.PATH,
        loadComponent: () => import('./maintenance/maintenance').then(m => m.Maintenance),
        pathMatch: "full",
        data: { auth: 'required', hideHeader: true, hideFooter: true, hideSubHeader: true, pageCategory: 'maintenance page' },
        //canActivate: [AuthGuard],
        // resolve: { pageData: PageResolver },
      },
    

      {
  path: SRP_ROUTES.CREATERETURN.PATH,
  loadComponent: () =>
    import('./create-return/create-return')
      .then(m => m.CreateReturn),
  data: {
    auth: 'required',
    pageCategory: 'create return page'
  },
  children: [
    {
      path: SRP_ROUTES.WARRANTYDETAILS.PATH,
      loadComponent: () =>
        import('./create-return/warranty-details/warranty-details')
          .then(m => m.WarrantyDetails),
      data: {
        auth: 'required',
        pageCategory: 'warranty details page'
      }
    }
  ]
}



    ]
  }
];


